/**
 * Utility for rounding and formatting cooking durations.
 *
 * Rules:
 * - < 15 min: no rounding (exact minutes)
 * - 15 <= min < 60: rounded to nearest 5 minutes (>= 57m rounds to 1h)
 * - >= 60 min: rounded to 00 / 15 / 30 / 45 minute intervals (15 min steps)
 *
 * Display Format:
 * - < 60 min: "X Min." (e.g. "12 Min.", "25 Min.")
 * - >= 60 min with 0 remaining: "Xh" (e.g. "1h", "2h")
 * - >= 60 min with remaining: "Xh Ym" (e.g. "1h 15m", "1h 30m", "1h 45m")
 */

export function roundDuration(mins: number): number {
  if (!mins || mins <= 0) return 0
  if (mins < 15) return Math.round(mins)
  if (mins >= 57) {
    return Math.round(mins / 15) * 15
  }
  return Math.round(mins / 5) * 5
}

export function formatDuration(mins: number | undefined | null): string {
  if (!mins || mins <= 0) return '0 Min.'
  const rounded = roundDuration(mins)
  if (rounded < 60) {
    return `${rounded} Min.`
  }
  const hours = Math.floor(rounded / 60)
  const remainingMins = rounded % 60
  if (remainingMins === 0) {
    return `${hours}h`
  }
  return `${hours}h ${remainingMins}m`
}
